module.exports = __webpack_public_path__ + "static/media/ic_searchtype_spot.d35129cd.svg";